import { render, staticRenderFns } from "./ValidationIndicator.vue?vue&type=template&id=61d81de2"
import script from "./ValidationIndicator.vue?vue&type=script&lang=js"
export * from "./ValidationIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports